import { Icon, type IconTone } from './Icon';

/** Решения модерации: лист с галочкой. */
export function VerdictIcon({ size = 20, tone }: { size?: number; tone?: IconTone }) {
  return (
    <Icon size={size} box={20} tone={tone}>
      <rect x="2.8" y="3" width="14.4" height="14" rx="1" />
      <path d="M6 8.4 l2 2 l3.6 -3.8" />
      <path d="M6 13.4 h8" />
    </Icon>
  );
}
